import { useCallback, useState } from 'react';
import { Documentation } from 'graphql-common';

type Params = {
  onMarkAsRead: (
    documentationId: string,
    versionId: string,
    versionViewId: string,
  ) => void;
};

export default function useFileViewerMarkAsRead({ onMarkAsRead }: Params) {
  const [fileViewerDocument, setFileViewerDocument] =
    useState<Documentation | null>(null);

  const openFileViewer = useCallback((doc: Documentation) => {
    setFileViewerDocument(doc);
  }, []);

  const closeFileViewer = useCallback(() => {
    setFileViewerDocument(null);
  }, []);

  // `readingDurationSeconds` isn't needed here — `FileViewerModal` only calls
  // this once the record is already created/incremented, so all that's left
  // to do is remember its id and close.
  const handleMarkAsRead = useCallback(
    (_readingDurationSeconds: number, versionViewId: string) => {
      if (!fileViewerDocument) return;
      const versionId = fileViewerDocument.currentVersion?.id;
      if (!versionId) return;
      onMarkAsRead(fileViewerDocument.id, versionId, versionViewId);
      setFileViewerDocument(null);
    },
    [fileViewerDocument, onMarkAsRead],
  );

  return {
    fileViewerDocument,
    openFileViewer,
    closeFileViewer,
    handleMarkAsRead,
  };
}
